import { render, staticRenderFns } from "./TopRooms.vue?vue&type=template&id=452677b6&"
import script from "./TopRooms.vue?vue&type=script&lang=js&"
export * from "./TopRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports